import { BranchesComponent } from "../../../../features/company-management/branches/branches.component";

// USA
export const enLocale = {
   lang: 'en',
   data: {
      TRANSLATOR: {
         SELECT: 'Select your language',
      },
      MENU: {
         NEW: 'new',
         ACTIONS: 'Actions',
         CREATE_POST: 'Create New Post',
         PAGES: 'Pages',
         FEATURES: 'Features',
         APPS: 'Apps',
         DASHBOARD: 'Dashboard',
         REPORTS: 'Reports',
         ACCOUNTS: 'Accounts',
         ACCOUNT_OVERVIEW: 'Overview',
         ACCOUNT_SETTINGS: 'Settings',
         ACCOUNT_EMPLOYEE: 'Employee',
         ACCOUNT_COVENANTS: 'Covenants',
         ACCOUNT_THEME: 'Theme',
         ADMINISTRATOR: 'Administrator',
         USER_MANAGEMENT: 'User Management',
         USERS: 'Users',
         USERS_LIST: 'Users List',
         ROLES: 'Roles',
         ROLES_LIST: 'Roles List',
         PERMISSIONS: 'Permissions',
         LOCATION: 'Location',
         LOCATION_MANAGEMENT: 'Location Management',
         COUNTRIES: 'Countries',
         COUNTRIES_LIST: 'Countries List',
         STATES: 'States',
         STATES_LIST: 'States List',
         HR_TEAM: 'HR Team',
         COMPANY_MANAGEMENT: 'Company Management',
         COMPANIES: 'Companies',
         VIEW_COMPANY: 'View Company',
         BRANCHES: 'Branches',
         BRANCHES_LIST: 'Branches List',
         DEPARTMENT_MANAGEMENT: 'Department Management',
         DEPARTMENTS_LIST: 'Departments List',
         JOB_MANAGEMENT: 'Job Management',
         JOBS_LIST: 'Jobs List',
         EMPLOYEE_MANAGEMENT: 'Employee Management',
         EMPLOYEES_LIST: 'Employees List',
         IT_TEAM: 'IT Team',
         TICKET_MANAGEMENT: 'Ticket Management',
         TICKETS: 'Tickets',
         TICKETS_LIST: 'Tickets List',
         ASSIGNED_TICKETS: 'Assigned Tickets',
         APPROVE_TICKETS: 'Approve Tickets',
         TYPES: 'Types'
      },
      NAV_MENU: {
         MY_PROFILE: "My Profile",
         ACCOUNT_SETTINGS: "Account Settings",
         SIGN_OUT: "Sign Out",
         LANGUAGE: "Language"
      },
      BRANCHES: {
         MAIN: "Head Office",
      },
      AUTH: {
         GENERAL: {
            OR: 'Or',
            SUBMIT_BUTTON: 'Submit',
            NO_ACCOUNT: 'Don\'t have an account?',
            SIGNUP_BUTTON: 'Sign Up',
            FORGOT_BUTTON: 'Forgot Password',
            BACK_BUTTON: 'Back',
            PRIVACY: 'Privacy',
            LEGAL: 'Legal',
            CONTACT: 'Contact',
         },
         LOGIN: {
            TITLE: 'Login Account',
            BUTTON: 'Sign In',
         },
         FORGOT: {
            TITLE: 'Forgotten Password?',
            DESC: 'Enter your email to reset your password',
            SUCCESS: 'Your account has been successfully reset.'
         },
         REGISTER: {
            TITLE: 'Sign Up',
            DESC: 'Enter your details to create your account',
            SUCCESS: 'Your account has been successfuly registered.'
         },
         INPUT: {
            EMAIL: 'Email',
            FULLNAME: 'Fullname',
            PASSWORD: 'Password',
            CONFIRM_PASSWORD: 'Confirm Password',
            USERNAME: 'Username'
         },
         VALIDATION: {
            INVALID: '{{name}} is not valid',
            REQUIRED: '{{name}} is required',
            MIN_LENGTH: '{{name}} minimum length is {{min}}',
            AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
            NOT_FOUND: 'The requested {{name}} is not found',
            INVALID_LOGIN: 'The login detail is incorrect',
            REQUIRED_FIELD: 'Required field',
            MIN_LENGTH_FIELD: 'Minimum field length:',
            MAX_LENGTH_FIELD: 'Maximum field length:',
            INVALID_FIELD: 'Field is not valid',
         }
      },
      ECOMMERCE: {
         COMMON: {
            SELECTED_RECORDS_COUNT: 'Selected records count: ',
            ALL: 'All',
            SUSPENDED: 'Suspended',
            ACTIVE: 'Active',
            FILTER: 'Filter',
            BY_STATUS: 'by Status',
            BY_TYPE: 'by Type',
            BUSINESS: 'Business',
            INDIVIDUAL: 'Individual',
            SEARCH: 'Search',
            IN_ALL_FIELDS: 'in all fields'
         },
         ECOMMERCE: 'eCommerce',
         CUSTOMERS: {
            CUSTOMERS: 'Customers',
            CUSTOMERS_LIST: 'Customers list',
            NEW_CUSTOMER: 'New Customer',
            DELETE_CUSTOMER_SIMPLE: {
               TITLE: 'Customer Delete',
               DESCRIPTION: 'Are you sure to permanently delete this customer?',
               WAIT_DESCRIPTION: 'Customer is deleting...',
               MESSAGE: 'Customer has been deleted'
            },
            DELETE_CUSTOMER_MULTY: {
               TITLE: 'Customers Delete',
               DESCRIPTION: 'Are you sure to permanently delete selected customers?',
               WAIT_DESCRIPTION: 'Customers are deleting...',
               MESSAGE: 'Selected customers have been deleted'
            },
            UPDATE_STATUS: {
               TITLE: 'Status has been updated for selected customers',
               MESSAGE: 'Selected customers status have successfully been updated'
            },
            EDIT: {
               UPDATE_MESSAGE: 'Customer has been updated',
               ADD_MESSAGE: 'Customer has been created'
            }
         }
      }
   }
};
